export default __webpack_public_path__ + "static/13-aabfe726b5c2a645c3e5b5b35f7a7333.webp";